'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _campaigns = require('./campaigns.html');

var _campaigns2 = _interopRequireDefault(_campaigns);

var _campaignAdd = require('./campaignAdd.html');

var _campaignAdd2 = _interopRequireDefault(_campaignAdd);

var _campaignDetail = require('./campaignDetail.html');

var _campaignDetail2 = _interopRequireDefault(_campaignDetail);

var _campaignContactDetail = require('./campaignContactDetail.html');

var _campaignContactDetail2 = _interopRequireDefault(_campaignContactDetail);

var _motherCampaignAdd = require('./motherCampaignAdd.html');

var _motherCampaignAdd2 = _interopRequireDefault(_motherCampaignAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
var CampaignsConfig = function CampaignsConfig($stateProvider) {
    $stateProvider.state('campaigns', {
        url: '/campaigns?type',
        template: _campaigns2.default,
        controller: 'CampaignsController',
        controllerAs: 'campaigns',
        params: { campaignType: 'CAMPAIGN' }
    }).state('motherCampaignAdd', {
        url: '/campaigns/add/mother',
        template: _motherCampaignAdd2.default,
        controller: 'motherCampaignAddController',
        controllerAs: 'campaignAdd'
    }).state('motherCampaignEdit', {
        url: '/mother-campaigns/edit/:campaignId',
        template: _motherCampaignAdd2.default,
        controller: 'motherCampaignAddController',
        controllerAs: 'campaignAdd'
    }).state('campaignAdd', {
        url: '/campaigns/add?type',
        template: _campaignAdd2.default,
        controller: 'CampaignAddController',
        controllerAs: 'campaignAdd'
    }).state('campaignEdit', {
        url: '/campaigns/edit/:campaignId',
        template: _campaignAdd2.default,
        controller: 'CampaignAddController',
        controllerAs: 'campaignAdd'
    }).state('campaignContactDetail', {
        url: '/campaigns/:campaignId/contacts/:contactId',
        template: _campaignContactDetail2.default,
        controller: 'CampaignContactDetailController',
        controllerAs: 'campaignContact'
    }).state('campaignDetail', {
        url: '/campaigns/:campaignId/:sortOrder/:level',
        template: _campaignDetail2.default,
        controller: 'CampaignDetailController',
        controllerAs: 'campaign'
    });
};

exports.default = CampaignsConfig;


/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaigns.config.js
 **/